import Print from './packages/print.js';
Print.install = function(Vue) {
    Vue.directive('print', Print);
};

export default Print;


// WEBPACK FOOTER //
// ./src/js/vue-print-nb/print/index.js